import StickyToolbar from '../../../../Components/StickyToolbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormProvider, useForm } from 'react-hook-form';
import UnForm from '../../../../Components/Form';
import { faFilter, faTimes } from '@fortawesome/free-solid-svg-icons';
import StorageManagerCapys from '../../../../Tools/Storage';
import { ITitulos } from '../../../../Interfaces/Cobranca/Titulos/TitulosInterface';

export interface ITitulosFilterProps {
    handleSubmit: (filter: ITitulos) => void,
    defaultFilter?: ITitulos,
    storageManager: StorageManagerCapys<ITitulos>
}

export default function TitulosFilter(props: ITitulosFilterProps) {

    const filter = props.defaultFilter;
    const hadleFilterFormSubmit = props.handleSubmit;

    const FormMethods = useForm();
    const { reset } = FormMethods;


    function handleData(date: string) {
        const dataCerta = date.split('T')
        return dataCerta[0]
    }


    return (
        <StickyToolbar active={Boolean(filter)}>
            <FormProvider {...FormMethods}>
                <UnForm
                    usingContext
                    handleSubmit={hadleFilterFormSubmit}
                    className="row no-gutters"
                >
                    <div className="col-12 mt-3">
                        <UnForm.Input
                            type="date"
                            defaultValue={filter?.DT_MES_REFERENCIA_INICIO && handleData(filter?.DT_MES_REFERENCIA_INICIO)}
                            name="DT_MES_REFERENCIA_INICIO"
                            label="Data Referência Início"
                            
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <UnForm.Input
                            type="date"
                            defaultValue={filter?.DT_MES_REFERENCIA_FIM && handleData(filter?.DT_MES_REFERENCIA_FIM)}
                            name="DT_MES_REFERENCIA_FIM"
                            label="Data Referência Fim"
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <UnForm.Input
                            type="date"
                            defaultValue={filter?.DT_VENCIMENTO_INICIO && handleData(filter?.DT_VENCIMENTO_INICIO)}
                            name="DT_VENCIMENTO_INICIO"
                            label="Data Vencimento Início"
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <UnForm.Input
                            type="date"
                            defaultValue={filter?.DT_VENCIMENTO_FIM && handleData(filter?.DT_VENCIMENTO_FIM)}
                            name="DT_VENCIMENTO_FIM"
                            label="Data Vencimento Fim"
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <UnForm.Input
                            type="number"
                            defaultValue={filter?.ID_EMPRESA ?? 0}
                            name="ID_EMPRESA"
                            label="Empresa"
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <UnForm.Input
                            type="number"
                            defaultValue={filter?.ID_VENDA ?? 0}
                            name="ID_VENDA"
                            label="Venda"
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <UnForm.Input
                            type="text"
                            defaultValue={filter?.DS_CLASSIFICACAO_CONTRATO ?? ''}
                            name="DS_CLASSIFICACAO_CONTRATO"
                            label="Classificação"
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <UnForm.Input
                            type="text"
                            defaultValue={filter?.DS_CLIENTE ?? ''}
                            name="DS_CLIENTE"
                            label="Cliente"
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <UnForm.Input
                            type="text"
                            defaultValue={filter?.DS_IDENTIFICADOR ?? ''}
                            name="DS_IDENTIFICADOR"
                            label="Identificador"
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <UnForm.Input
                            type="text"
                            defaultValue={filter?.ID_TIPO_PARCELA ?? ''}
                            name="ID_TIPO_PARCELA"
                            label="Tipo Parcela"
                        />
                    </div>
                    <div className="col-12 mt-3">
                        <UnForm.Input
                            type="text"
                            defaultValue={filter?.ID_OBRA ?? ''}
                            name="ID_OBRA"
                            label="Obra"
                        />
                    </div>
                    <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                        <button type="submit"
                            className="btn btn-block btn-outline-dark mt-2">
                            <FontAwesomeIcon icon={faFilter} className="mr-2" />
                            Filtrar
                        </button>
                    </div>
                    <div className="col-12 d-flex align-items-end justify-content-start">
                        <button type="button" onClick={() => {
                            reset({DT_FILTRO_FINAL: '', DT_FILTRO_INICIO: ''});
                        }} className="btn btn-block btn-outline-danger mt-2">
                            <FontAwesomeIcon icon={faTimes} className="mr-2" />
                            Limpar Filtros
                        </button>
                    </div>
                </UnForm>
            </FormProvider>
        </StickyToolbar>
    )
}